import { MultiChoiceType } from 'components/multichoice-button';

export const getMultiChoiceButtonSelectOptions = (pageValue: string[], multiChoices: MultiChoiceType[]) => {
    return pageValue.map((item: string) => {
        const currentOption = multiChoices.find((option) => option.key === item);

        return currentOption?.key === 'other' ? `${currentOption.value}: ${currentOption?.userAnswer?.toString()?.trim()}` : currentOption?.value;
    }) as string[];
};
